import { render } from "./LoginBtn.vue?vue&type=template&id=68c48830&scoped=true"
import script from "./LoginBtn.vue?vue&type=script&lang=js"
export * from "./LoginBtn.vue?vue&type=script&lang=js"

import "./LoginBtn.vue?vue&type=style&index=0&id=68c48830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c48830"]])

export default __exports__